import React, { useState, useEffect, useContext } from "react";
import * as S from "./PaginaContratoStyle";
import {
  formatCPFCriarCliente,
  formatCurrencyBRL,
  formatDate,
  formatDateForInput,
  formatDateSystem,
} from "../ASSETS/assets";
import Loading from "../Loader";
import { FaTimes, FaCalendarAlt, FaExpand } from "react-icons/fa";
import { useMessage } from "../../Context/MessageContext";
import { contractAdminService } from "../../Services/contractAdminService";

function ModalDatasSaque({ dates, onClose }) {
  const now = new Date();
  const todayStart = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate()
  ).getTime();

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0,0,0,0.85)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 3000,
        backdropFilter: "blur(6px)",
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: "#1c1c1c",
          padding: "40px",
          borderRadius: "16px",
          width: "95%",
          maxWidth: "900px", // Aumentado para caber mais colunas
          maxHeight: "90vh",
          overflowY: "auto",
          border: "1px solid rgba(230, 170, 58, 0.3)",
          boxShadow: "0 20px 50px rgba(0,0,0,0.5)",
          position: "relative",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Botão X de fechar no topo */}
        <button
          onClick={onClose}
          style={{
            position: "absolute",
            top: "20px",
            right: "20px",
            background: "transparent",
            border: "none",
            color: "#fff",
            fontSize: "24px",
            cursor: "pointer",
            opacity: 0.6,
            transition: "0.3s",
          }}
          onMouseOver={(e) => (e.target.style.opacity = 1)}
          onMouseOut={(e) => (e.target.style.opacity = 0.6)}
        >
          <FaTimes />
        </button>

        <h3
          style={{
            color: "#E6AA3A",
            marginBottom: "30px",
            fontSize: "22px",
            display: "flex",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <FaCalendarAlt size={20} /> Cronograma de Saques do Contrato
        </h3>

        {/* Grid de 2 colunas para economizar espaço vertical */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))",
            gap: "15px",
          }}
        >
          {dates.map((dStr, index) => {
            const d = new Date(dStr);
            const dTimestamp = new Date(
              d.getUTCFullYear(),
              d.getUTCMonth(),
              d.getUTCDate()
            ).getTime();

            let color = "#3498db"; // Azul (Futuro)
            let label = "PRÓXIMO";
            let opacity = 1;

            if (dTimestamp === todayStart) {
              color = "#00ff00"; // Verde (Hoje)
              label = "HOJE";
            } else if (dTimestamp < todayStart) {
              color = "#e74c3c"; // Vermelho (Passado)
              label = "PASSADO";
              opacity = 0.6; // Deixa o que já passou mais discreto
            }

            return (
              <div
                key={index}
                style={{
                  padding: "15px",
                  borderRadius: "8px",
                  borderLeft: `4px solid ${color}`,
                  background: "rgba(255,255,255,0.03)",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  opacity: opacity,
                  border:
                    dTimestamp === todayStart
                      ? `1px solid ${color}`
                      : "1px solid transparent",
                }}
              >
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <span
                    style={{
                      color: "#fff",
                      fontSize: "16px",
                      fontWeight: "500",
                    }}
                  >
                    {String(d.getUTCDate()).padStart(2, "0")}/
                    {String(d.getUTCMonth() + 1).padStart(2, "0")}/
                    {d.getUTCFullYear()}
                  </span>
                  <span
                    style={{ color: "rgba(255,255,255,0.4)", fontSize: "11px" }}
                  >
                    Ref. Saque #{index + 1}
                  </span>
                </div>
                <span
                  style={{
                    color: color,
                    fontSize: "11px",
                    fontWeight: "bold",
                    background: `rgba(${
                      color === "#00ff00"
                        ? "0,255,0"
                        : color === "#e74c3c"
                        ? "231,76,60"
                        : "52,152,219"
                    }, 0.1)`,
                    padding: "4px 8px",
                    borderRadius: "4px",
                  }}
                >
                  {label}
                </span>
              </div>
            );
          })}
        </div>

        <div style={{ marginTop: "40px", textAlign: "right" }}>
          <button
            onClick={onClose}
            style={{
              padding: "12px 30px",
              background: "rgba(255,255,255,0.05)",
              color: "#fff",
              border: "1px solid rgba(255,255,255,0.1)",
              borderRadius: "6px",
              cursor: "pointer",
              fontWeight: "600",
              transition: "0.3s",
            }}
            onMouseOver={(e) =>
              (e.target.style.background = "rgba(255,255,255,0.1)")
            }
            onMouseOut={(e) =>
              (e.target.style.background = "rgba(255,255,255,0.05)")
            }
          >
            Fechar Janela
          </button>
        </div>
      </div>
    </div>
  );
}

export default function PaginaContrato({
  handleClose,
  contratoData,
  refreshData,
}) {
  const { showMessage } = useMessage();

  const [isLoading, setIsLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [hasChanges, setHasChanges] = useState(false);
  const [editedData, setEditedData] = useState({});
  const [prolongData, setProlongData] = useState({});
  const [buybackConfirmation, setBuybackConfirmation] = useState("");
  const [cancelConfirmation, setCancelConfirmation] = useState("");
  const [showDatesModal, setShowDatesModal] = useState(false);
  const [showNotesModal, setShowNotesModal] = useState(false);

  console.log(contratoData);

  useEffect(() => {
    if (!contratoData) return;
    const { contract } = contratoData;

    setEditedData({
      MAXIMUMQUOTAYIELD: contract.maxValorization || "",
      PRIMEIRO_RENDIMENTO: formatDateForInput(contract.firstValorization),
      RENDIMENTO_ATUAL: `${contract.actualValorization?.toFixed(2) || "0.00"}`,
    });

    setProlongData({
      newDuration: contract.duration || "",
      newMaxValorization: contract.maxValorization || "",
    });

    setBuybackConfirmation("");
    setCancelConfirmation("");
    setHasChanges(false);
  }, [contratoData]);

  const getNextWithdrawalInfo = (withdrawDates) => {
    if (!withdrawDates || withdrawDates.length === 0) return "Não definido";
    const now = new Date();
    const todayStart = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate()
    ).getTime();

    const futureDates = withdrawDates
      .map((d) => ({
        original: d,
        ts: new Date(
          new Date(d).getUTCFullYear(),
          new Date(d).getUTCMonth(),
          new Date(d).getUTCDate()
        ).getTime(),
      }))
      .filter((d) => d.ts >= todayStart)
      .sort((a, b) => a.ts - b.ts);

    if (futureDates.length === 0) return "Finalizado";

    const next = futureDates[0];
    if (next.ts === todayStart) return "HOJE";

    const d = new Date(next.original);
    return `${String(d.getUTCDate()).padStart(2, "0")}/${String(
      d.getUTCMonth() + 1
    ).padStart(2, "0")}/${d.getUTCFullYear()}`;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditedData((prevState) => ({ ...prevState, [name]: value }));
    setHasChanges(true);
  };

  const handleProlongInputChange = (e) => {
    const { name, value } = e.target;
    setProlongData((prevState) => ({ ...prevState, [name]: value }));
  };

  const handleSave = async () => {
    if (!hasChanges) return;
    if (
      !window.confirm("Deseja salvar as alterações nos detalhes do contrato?")
    )
      return;

    setIsSaving(true);
    try {
      const payload = {
        actualValorization: parseFloat(editedData.RENDIMENTO_ATUAL),
        maxValorization: parseInt(editedData.MAXIMUMQUOTAYIELD, 10),
        firstValorization: editedData.PRIMEIRO_RENDIMENTO || null,
      };
      await contractAdminService.updateContractDetails(
        contratoData.contract.id,
        payload
      );
      showMessage("Alterações salvas com sucesso!", "success");
      if (refreshData) refreshData();
      handleClose();
    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        "Não foi possível salvar as alterações.";
      showMessage(`Erro: ${errorMessage}`, "error");
    } finally {
      setIsSaving(false);
    }
  };

  const handleProlongarContrato = async () => {
    const { newDuration, newMaxValorization } = prolongData;
    if (!newDuration || !newMaxValorization) {
      showMessage(
        "Por favor, preencha a nova duração e o novo teto de lucro.",
        "warning"
      );
      return;
    }
    if (
      !window.confirm(
        "Você tem certeza que deseja prolongar/reativar este contrato?"
      )
    )
      return;

    setIsLoading(true);
    try {
      const payload = {
        newDuration: parseInt(newDuration, 10),
        newMaxValorization: parseInt(newMaxValorization, 10),
      };
      await contractAdminService.prolongContract(
        contratoData.contract.id,
        payload
      );
      showMessage("Contrato prolongado/reativado com sucesso!", "success");
      if (refreshData) refreshData();
      handleClose();
    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        "Não foi possível prolongar o contrato.";
      showMessage(`Erro: ${errorMessage}`, "error");
    } finally {
      setIsLoading(false);
    }
  };

  const handleRecomprar = async () => {
    if (buybackConfirmation !== "SIM") {
      showMessage(
        "Você deve digitar 'SIM' para confirmar a recompra.",
        "warning"
      );
      return;
    }
    if (
      !window.confirm(
        "ATENÇÃO: Esta ação é irreversível e mudará o status do contrato. Deseja continuar?"
      )
    )
      return;

    setIsLoading(true);
    try {
      await contractAdminService.buybackContract(contratoData.contract.id);
      showMessage("Recompra realizada com sucesso!", "success");
      if (refreshData) refreshData();
      handleClose();
    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        "Não foi possível realizar a recompra.";
      showMessage(`Erro: ${errorMessage}`, "error");
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancelar = async () => {
    if (cancelConfirmation !== "SIM") {
      showMessage(
        "Você deve digitar 'SIM' para confirmar o cancelamento.",
        "warning"
      );
      return;
    }
    if (!window.confirm("ATENÇÃO: Esta ação é irreversível. Deseja continuar?"))
      return;

    setIsLoading(true);
    try {
      await contractAdminService.cancelContract(
        contratoData.contract.id,
        contratoData.contract.clientId
      );
      showMessage("Contrato cancelado com sucesso!", "success");
      if (refreshData) refreshData();
      handleClose();
    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        "Não foi possível cancelar o contrato.";
      showMessage(`Erro: ${errorMessage}`, "error");
    } finally {
      setIsLoading(false);
    }
  };

  if (!contratoData) return null;

  const { contract, clientName, clientCpfCnpj } = contratoData;
  const nextWithdrawal = getNextWithdrawalInfo(contract.withdrawDates);

  return (
    <S.PaginaContratoContainer onClick={handleClose}>
      <S.Drawer onClick={(e) => e.stopPropagation()}>
        <Loading load={isLoading || isSaving} />
        <S.Header>
          <h2>Detalhes do Contrato #{contract.id}</h2>
          <S.CloseButton as="button" onClick={handleClose}>
            <FaTimes />
          </S.CloseButton>
        </S.Header>

        <S.MainContent>
          <S.Section>
            <h3>Informações Gerais</h3>
            <S.InfoGrid>
              <S.InfoBox>
                <label>Cliente</label>
                <input value={clientName} className="desabilitado" readOnly />
              </S.InfoBox>
              <S.InfoBox>
                <label>CPF/CNPJ</label>
                <input
                  value={formatCPFCriarCliente(clientCpfCnpj)}
                  className="desabilitado"
                  readOnly
                />
              </S.InfoBox>
              <S.InfoBox>
                <label>Data da Compra</label>
                <input
                  value={formatDateSystem(contract.dateCreated)}
                  className="desabilitado"
                  readOnly
                />
              </S.InfoBox>
              <S.InfoBox>
                <label>Finaliza em</label>
                <input
                  value={formatDateForInput(contract.endContractDate)}
                  className="desabilitado"
                  readOnly
                />
              </S.InfoBox>
              <S.InfoBox>
                <label>Recompra</label>
                <input
                  value={contract.isRepurchase ? "SIM" : "NÃO"}
                  className="desabilitado"
                  readOnly
                  style={{ color: contract.isRepurchase ? "#E6AA3A" : "#fff" }}
                />
              </S.InfoBox>
            </S.InfoGrid>
          </S.Section>

          {contract.notes && (
            <S.Section>
              <h3 style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                Anotações
                <button
                  onClick={() => setShowNotesModal(true)}
                  style={{
                    background: "rgba(230, 170, 58, 0.1)",
                    border: "1px solid rgba(230, 170, 58, 0.3)",
                    borderRadius: "6px",
                    color: "#E6AA3A",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    fontSize: "12px",
                    fontWeight: "600",
                    padding: "5px 12px",
                    transition: "background 0.2s",
                  }}
                >
                  <FaExpand size={11} /> VER EM TELA CHEIA
                </button>
              </h3>
              <S.InfoGrid>
                <S.InfoBox style={{ gridColumn: "1 / -1" }}>
                  <textarea
                    value={contract.notes}
                    readOnly
                    rows={4}
                    style={{
                      width: "100%",
                      background: "rgba(230, 170, 58, 0.05)",
                      border: "1px solid rgba(230, 170, 58, 0.2)",
                      borderRadius: "8px",
                      color: "#ccc",
                      padding: "12px 14px",
                      fontSize: "0.9rem",
                      resize: "none",
                      fontFamily: "inherit",
                      lineHeight: "1.6",
                      boxSizing: "border-box",
                    }}
                  />
                </S.InfoBox>
              </S.InfoGrid>
            </S.Section>
          )}

          <S.Section>
            <h3>Cronograma de Saque</h3>
            <S.InfoGrid>
              <S.InfoBox>
                <label>Próxima Data de Saque</label>
                <div
                  style={{ display: "flex", alignItems: "center", gap: "10px" }}
                >
                  <input
                    value={nextWithdrawal}
                    className="desabilitado"
                    readOnly
                    style={{
                      color: nextWithdrawal === "HOJE" ? "#00ff00" : "#fff",
                      fontWeight: "bold",
                      width: "120px",
                    }}
                  />
                  <button
                    onClick={() => setShowDatesModal(true)}
                    style={{
                      background: "#E6AA3A",
                      border: "none",
                      borderRadius: "4px",
                      padding: "6px 12px",
                      fontSize: "12px",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      fontWeight: "bold",
                      color: "#111",
                    }}
                  >
                    <FaCalendarAlt /> VER TODAS
                  </button>
                </div>
              </S.InfoBox>
            </S.InfoGrid>
          </S.Section>

          <S.Section>
            <h3>Valores e Rendimentos</h3>
            <S.InfoGrid>
              <S.InfoBox>
                <label>Valor Investido</label>
                <input
                  value={`R$ ${formatCurrencyBRL(
                    parseFloat(contract.totalPrice || 0)
                  )}`}
                  className="desabilitado"
                  readOnly
                />
              </S.InfoBox>
              <S.InfoBox>
                <label>Primeiro Rendimento</label>
                <input
                  type="date"
                  name="PRIMEIRO_RENDIMENTO"
                  disabled={contract.status === 5}
                  className={contract.status === 5 ? "desabilitado" : ""}
                  value={editedData.PRIMEIRO_RENDIMENTO}
                  onChange={handleInputChange}
                />
              </S.InfoBox>
              <S.InfoBox>
                <label>Rendimento Atual (%)</label>
                <input
                  name="RENDIMENTO_ATUAL"
                  disabled={contract.status === 5}
                  value={editedData.RENDIMENTO_ATUAL}
                  className={contract.status === 5 ? "desabilitado" : ""}
                  onChange={handleInputChange}
                />
              </S.InfoBox>
              <S.InfoBox>
                <label>Teto de Lucro (%)</label>
                <input
                  name="MAXIMUMQUOTAYIELD"
                  disabled={contract.status === 5}
                  className={contract.status === 5 ? "desabilitado" : ""}
                  value={editedData.MAXIMUMQUOTAYIELD}
                  onChange={handleInputChange}
                />
              </S.InfoBox>
            </S.InfoGrid>
          </S.Section>

          {contract.status !== 5 && (
            <>
              <S.Section>
                <h3>Prolongar / Reativar Contrato</h3>
                <S.ActionGrid>
                  <p>
                    Altere a duração total (em meses) e o teto de lucro final.
                  </p>
                  <S.InfoGrid style={{ padding: 0, marginTop: "15px" }}>
                    <S.InfoBox>
                      <label>Duração Total (meses)</label>
                      <input
                        type="number"
                        name="newDuration"
                        value={prolongData.newDuration}
                        onChange={handleProlongInputChange}
                        placeholder="Ex: 48"
                      />
                    </S.InfoBox>
                    <S.InfoBox>
                      <label>Novo Teto de Lucro Final (%)</label>
                      <input
                        type="number"
                        name="newMaxValorization"
                        value={prolongData.newMaxValorization}
                        onChange={handleProlongInputChange}
                        placeholder="Ex: 200"
                      />
                    </S.InfoBox>
                  </S.InfoGrid>
                  <S.ActionButton
                    onClick={handleProlongarContrato}
                    style={{ width: "100%", marginTop: "20px" }}
                    disabled={isLoading || isSaving}
                  >
                    {isLoading ? "Processando..." : "Confirmar Prolongamento"}
                  </S.ActionButton>
                </S.ActionGrid>
              </S.Section>
              <S.Section>
                <h3>Ações Irreversíveis</h3>
                <S.ActionGrid>
                  <div>
                    <p>
                      <b>Cancelar Contrato:</b> Cancela o contrato sem recompra.
                    </p>
                    <input
                      className="confirm-input"
                      value={cancelConfirmation}
                      onChange={(e) => setCancelConfirmation(e.target.value)}
                      placeholder="Digite SIM para confirmar"
                    />
                    <S.ActionButton
                      onClick={handleCancelar}
                      className="cancel"
                      disabled={
                        cancelConfirmation !== "SIM" || isLoading || isSaving
                      }
                    >
                      Cancelar Contrato
                    </S.ActionButton>
                  </div>
                  <hr
                    style={{
                      width: "100%",
                      border: "1px solid rgba(255,255,255,0.1)",
                      margin: "20px 0",
                    }}
                  />
                  <div>
                    <p>
                      <b>Realizar Recompra:</b> Recompra o contrato
                      permanentemente.
                    </p>
                    <input
                      className="confirm-input"
                      value={buybackConfirmation}
                      onChange={(e) => setBuybackConfirmation(e.target.value)}
                      placeholder="Digite SIM para confirmar"
                    />
                    <S.ActionButton
                      onClick={handleRecomprar}
                      className="danger"
                      disabled={
                        buybackConfirmation !== "SIM" || isLoading || isSaving
                      }
                    >
                      Realizar Recompra
                    </S.ActionButton>
                  </div>
                </S.ActionGrid>
              </S.Section>
            </>
          )}
        </S.MainContent>

        <S.Footer>
          <S.CloseButton as="button" onClick={handleClose}>
            Fechar
          </S.CloseButton>
          {contract.status !== 5 && (
            <S.SaveButton
              onClick={handleSave}
              disabled={!hasChanges || isSaving || isLoading}
            >
              {isSaving ? "Salvando..." : "Salvar Alterações"}
            </S.SaveButton>
          )}
        </S.Footer>
      </S.Drawer>

      {showDatesModal && (
        <ModalDatasSaque
          dates={contract.withdrawDates || []}
          onClose={() => setShowDatesModal(false)}
        />
      )}

      {showNotesModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.85)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 3000,
            backdropFilter: "blur(6px)",
          }}
          onClick={() => setShowNotesModal(false)}
        >
          <div
            style={{
              background: "#1c1c1c",
              padding: "40px",
              borderRadius: "16px",
              width: "95%",
              maxWidth: "800px",
              maxHeight: "90vh",
              display: "flex",
              flexDirection: "column",
              border: "1px solid rgba(230, 170, 58, 0.3)",
              boxShadow: "0 20px 50px rgba(0,0,0,0.5)",
              position: "relative",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => setShowNotesModal(false)}
              style={{
                position: "absolute",
                top: "20px",
                right: "20px",
                background: "transparent",
                border: "none",
                color: "#fff",
                fontSize: "22px",
                cursor: "pointer",
                opacity: 0.6,
                transition: "0.2s",
              }}
              onMouseOver={(e) => (e.target.style.opacity = 1)}
              onMouseOut={(e) => (e.target.style.opacity = 0.6)}
            >
              <FaTimes />
            </button>
            <h3 style={{ color: "#E6AA3A", margin: "0 0 24px 0", fontSize: "18px" }}>
              Anotações — Contrato #{contract.id}
            </h3>
            <textarea
              value={contract.notes}
              readOnly
              style={{
                flex: 1,
                minHeight: "400px",
                background: "rgba(230, 170, 58, 0.04)",
                border: "1px solid rgba(230, 170, 58, 0.2)",
                borderRadius: "10px",
                color: "#ddd",
                padding: "18px",
                fontSize: "1rem",
                lineHeight: "1.8",
                resize: "none",
                fontFamily: "inherit",
                boxSizing: "border-box",
              }}
            />
          </div>
        </div>
      )}
    </S.PaginaContratoContainer>
  );
}
